'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';
var commonlocalisations = require('../common/menu.localisations');

export class NavbarComponent {
  isCollapsed = true;

  constructor(GLOBALS, $location, Auth, common, notifications, $interval, $mdBottomSheet) {
    'ngInject';
    var that = this;
    this.vno = GLOBALS.vno;
    this.starttime = GLOBALS.starttime;
    this.endtime = GLOBALS.endtime;
    this.common = common;
    this.Auth = Auth;
    this.$location = $location;
    this.notifications = notifications;
    this.$mdBottomSheet = $mdBottomSheet;
    this.isLoggedIn = Auth.isLoggedInSync;
    this.isAdmin = Auth.isAdminSync;
    this.isModerator = Auth.isModeratorSync;
    this.getCurrentUser = Auth.getCurrentUserSync;
    this.unreadNotifications = 0;
    this.checkfortimelogout();
    if (!this.isAdmin() && !this.isModerator()) {
      this.checkTime = $interval(function() { that.checkfortimelogout(); }, 60000);
    }
    this.notifications.initialise(function(numberOfNotifications) {
      console.log("I got", numberOfNotifications, 'notifications.', that.notifications.getNotifications() );
      $interval(function(){
        that.unreadNotifications = that.notifications.getActives();
      }, 1500);
      common.setLoading(false);
    }, function(){
      common.setLoading(false);
    })
  }

  isActive(route) {
    if (route === 'notifications') {
      if (this.unreadNotifications <= 0) {
        return false;
      } else {
        return true;
      }
    }
    if (route === '/dashboard' && this.$location.path() === '/group') return true;
    if (route === '/dashboard' && this.$location.path() === '/messages') return true;
    return route === this.$location.path();
  }

  showNotifications(group) {
    this.$mdBottomSheet.show({
      template: require('./navbar.bottomsheet.html'),
      controller: 'navbarBottomSheetCtrl',
      isLockedOpen: true
    });
  }

  checkfortimelogout() {
      console.log('Checking times');
      var start = new Date();
      start.setHours(this.starttime[0],this.starttime[1],this.starttime[2]);
      var end = new Date();
      end.setHours(this.endtime[0],this.endtime[1],this.endtime[2]);
      var now = new Date();
      if (start.getTime() > now.getTime() || end.getTime() < now.getTime()) {
          console.log('Oooo bad boy.  Logging out')
          if (this.$location.path() != '/login') {
            this.$location.path('/closed');
          }
          this.Auth.logout();
      } else {
        console.log('Not logging out')
      }
  }
}

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: require('./navbar.html'),
    controller: NavbarComponent
  })
  .controller('navbarBottomSheetCtrl', function(GLOBALS, Auth, Util, common, $scope, $timeout, $mdBottomSheet, notifications, $location) {
    'ngInject'

    $scope.myNotifications = notifications.getNotifications();
    $scope.localisations = commonlocalisations[common.getLocale()];
    $scope.markAllAsRead = function() {
        notifications.markAllRead();
        console.log('markAllAsRead');
    };

    $scope.visitLink = function(id, link) {
        // mark as read
        console.log('Visiting', link);
        notifications.markAsRead(id, function(){}, function(){});
        $location.path(link);
        $scope.hideBottomSheet();
    };

    $scope.hideBottomSheet = function() {
      $mdBottomSheet.hide();
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js